export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9492.0b6c034b.jpg";